import axios from '@/libs/api.request'

// 获取救援列表
export const rescueList = (data) => {
    return axios.request({
      url: 'rescue/list',
      data: data,
      method: 'post',
    })
  }

//   删除救援
export const deleterescue = (data) => {
    return axios.request({
      url: 'rescue/del',
      data: data,
      method: 'post',
    })
}